angular.module('comcast.common.communication').factory('EnumResourceFactory', ['$resource', 'EndPointService', function ($resource, ResourceEndPointService) {
  'use strict';

  return $resource(ResourceEndPointService.enumEndPoint, null, {
    query: {
      method: 'GET',
      isArray: false
    }
  });
}]);